import React, { Component } from 'react';
import styles from './RangeInputSetter.scss';
import classNames from 'classnames/bind';
import Switch from 'react-ios-switch';

const cx = classNames.bind(styles);

class RangeInputSetter extends Component {
  state = {
    rangeValue: this.props.onAt,
    rangeBackgroundFix: {}
  };

  componentDidUpdate(prevProps) {
    if(prevProps.onAt !== this.props.onAt) {
      const {displayValues} = this.props.airIndexes;
      const max = displayValues[displayValues.length - 1];
      const backgroundSize = `${this.props.onAt/max * 100}% 100%`;
      this.setState({rangeValue: this.props.onAt, rangeBackgroundFix: {backgroundSize}});
    }
  }

  componentDidMount() {
    const {rangeValue} = this.state;
    const {displayValues} = this.props.airIndexes;
    const max = displayValues[displayValues.length - 1];
    const backgroundSize = `${rangeValue/max * 100}% 100%`;
    this.setState({rangeBackgroundFix: {backgroundSize}});
  }

  render() {
    const {
      airIndexes,
      switchChecked,
      onSwitchChange,
      onRangeMouseDown,
      onRangeMouseMove,
      onRangeMouseUp,
      rangeMouseDownFlag,
      rangeStep
    } = this.props;

    const {rangeValue, rangeBackgroundFix} = this.state;
    const rangeClickedClassName = cx('RangeInputSetter__range-wrapper--clicked');

    const scaleList = airIndexes.displayValues.map((scale, index) => (
      <span key={`scale-${index}`} className={cx('RangeInputSetter__scale')}>{scale}</span>
    ));
    
    return (
      <div className={cx('RangeInputSetter', { 'RangeInputSetter--disabled': !switchChecked })}>
        <div className={cx('RangeInputSetter__switch')}>
          <h5 className={cx('RangeInputSetter__switch-label')}>{airIndexes.name}</h5>
          <Switch
            checked={switchChecked}
            offColor={'#FFFFFF'}
            onChange={onSwitchChange}
            onColor={'#64C2E6'}
            pendingOffColor={'#E9ECEE'}
          />
        </div>

        <div className={cx('RangeInputSetter__sensor')}>
          <span className={cx('RangeInputSetter__sensor-on')}>ON</span>
          <h3 className={cx('RangeInputSetter__sensor-value')}>
            {rangeValue}
          </h3>
        </div>
        <div
          className={cx('RangeInputSetter__range-super-wrapper')}
        >
          <div style={rangeBackgroundFix} className={cx(
            'RangeInputSetter__range-wrapper'
          )} />
          <div className={cx(
            `RangeInputSetter__range-wrapper-${airIndexes.keyName}--clicked`,
            rangeMouseDownFlag && 'RangeInputSetter__range-wrapper--clicked--on'
          )} />
          <input
            onChange={e => {
              this.setState({rangeValue: e.target.value});
            }}
            onMouseDown={(e) => onRangeMouseDown(e, rangeClickedClassName)}
            onTouchStart={(e) => onRangeMouseDown(e, rangeClickedClassName)}
            onMouseMove={onRangeMouseMove}
            onTouchMove={onRangeMouseMove}
            onMouseUp={(e) => onRangeMouseUp(e, rangeValue)}
            onTouchEnd={(e) => onRangeMouseUp(e, rangeValue)}
            className={cx('RangeInputSetter__range')}
            type="range"
            min="0"
            max={airIndexes.displayValues[4]}
            value={rangeValue}
            step={rangeStep}
          />
          <div className={cx('RangeInputSetter__scale-wrapper')}>
            {scaleList}
          </div>
        </div>
      </div>
    );
  }
}

export default RangeInputSetter;



// WEBPACK FOOTER //
// ./src/app/thermostats/components/RangeInputSetter/RangeInputSetter.js